var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mr-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onBack()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "chevron-left" } }),
                  _vm._v("\n        Назад\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-navbar-nav", { staticClass: "mx-2" }, [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmit()
                            }
                          }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n            Сохранить\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "b-container",
                { staticClass: "my-2", attrs: { fluid: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-card",
                            { attrs: { "bg-variant": "light" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "2", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { label: "Период" } },
                                        [
                                          _c("month-picker", {
                                            attrs: {
                                              placeholder: "Выберите период",
                                              "min-year": 2025
                                            },
                                            model: {
                                              value: _vm.newItem.period,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "period",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.period"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "2", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-date",
                                            label: "Дата",
                                            "label-for": "input-salary-date"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-salary-date",
                                              size: "sm",
                                              type: "date"
                                            },
                                            model: {
                                              value: _vm.newItem.payment_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "payment_date",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.payment_date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "3", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-organization",
                                            label: "Организация",
                                            "label-for":
                                              "input-organization-select"
                                          }
                                        },
                                        [
                                          _c("organization-select", {
                                            ref: "organization_select",
                                            staticClass: "mb-1 mr-2",
                                            attrs: {
                                              id: "input-organization-select",
                                              "initial-id":
                                                _vm.newItem.organization_id
                                            },
                                            on: {
                                              onSelect: _vm.onSelectOrganization
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "2", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-type",
                                            label: "Тип выплаты",
                                            "label-for": "input-salary-type"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-select",
                                            {
                                              attrs: {
                                                id: "input-salary-type",
                                                size: "sm"
                                              },
                                              model: {
                                                value: _vm.newItem.type_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "type_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "newItem.type_id"
                                              }
                                            },
                                            _vm._l(_vm.types, function(option) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: { value: option.id }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(option.name) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "2", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-code",
                                            label: "Номер",
                                            "label-for": "input-salary-code"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-salary-code",
                                              type: "text",
                                              size: "sm",
                                              trim: ""
                                            },
                                            model: {
                                              value: _vm.newItem.code,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.code"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "2", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-income-type",
                                            label: "Вид дохода",
                                            "label-for":
                                              "input-salary-income-type"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-select",
                                            {
                                              attrs: {
                                                id: "input-salary-income-type",
                                                size: "sm"
                                              },
                                              model: {
                                                value:
                                                  _vm.newItem.income_type_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.newItem,
                                                    "income_type_id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newItem.income_type_id"
                                              }
                                            },
                                            _vm._l(_vm.incomeTypes, function(
                                              option
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: { value: option.id }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(option.name) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "3", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-salary-comment",
                                            label: "Комментарий",
                                            "label-for": "input-salary-comment"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-salary-comment",
                                              type: "text",
                                              size: "sm",
                                              trim: ""
                                            },
                                            model: {
                                              value: _vm.newItem.comment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "comment",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.comment"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "", "bg-variant": "light" } },
                            [
                              _c("b-card-header", [
                                _c("h6", { attrs: { id: "task-header" } }, [
                                  _vm._v("Итого")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                { attrs: { flush: "", "bg-variant": "light" } },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Выплачено\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(_vm.totalAmount)
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  НДФЛ\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(_vm.totalNdflAmount)
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Страховые\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.totalInsuranceAmount
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Пенс. до превыш.\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.totalPensionBeforeAmount
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Пенс. после превыш.\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              _vm.totalPensionAfterAmount
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("salary-staff-list", {
            attrs: { salary: _vm.newItem },
            on: { change: _vm.onChangeSalaryStaff }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b179a4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b179a4f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Salary.vue
// module id = null
// module chunks = 